<template>
  <v-tooltip
    :bottom="bottom"
    :top="top"
    :left="left"
    :right="right"
    content-class="bm-tooltip-contents"
    :color="color"
  >
    <slot />
    <template #activator="scope">
      <slot name="activator" v-bind="scope">
        <v-icon small class="no-print" v-on="scope.on">info</v-icon>
      </slot>
    </template>

    <template #append="slotProps">
      <slot name="append" v-bind="slotProps" />
    </template>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmTooltip",
  props: {
    bottom: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "#272D33",
    },
  },
});
</script>

<style scoped lang="sass">
.bm-tooltip-contents
  max-width: 20rem
  opacity: 1 !important
</style>
